import AttachmentList from '@/components/attachments/AttachmentList';

export default function SubmissionSummary({ text, attachments = [], emptyLabel = 'No response provided.' }) {
  if (!text?.trim() && !attachments.length) {
    return <p className="text-sm text-base-content/50">{emptyLabel}</p>;
  }

  return (
    <div className="space-y-3">
      {text?.trim() && <p className="whitespace-pre-wrap text-sm text-base-content/75">{text}</p>}
      <AttachmentList attachments={attachments} readOnly />
    </div>
  );
}
